const Lists = ({ lists, listId, setListId }) => {
  return (
    <div className="flex flex-col gap-4 sm:px-4 md:px-20 h-[400px] overflow-y-scroll">
      <p>
        Select a list from the connected Hubspot account to which new profile
        will be added.
      </p>
      <div className="flex flex-col gap-2">
        <label className="text-semibold text-gray-700">List Name</label>
        {lists?.length > 0 ? (
          <select
            className="border-gray-200 rounded-md text-sm text-gray-500"
            value={listId ? listId : ""}
            onChange={(e) => setListId(e.target.value)}
          >
            <option value="">Select a list</option>
            {lists?.map((list) => (
              <option key={list?.id} value={list?.id} className="">
                {list?.name}
              </option>
            ))}
          </select>
        ) : (
          <p className="text-gray-500 text-sm">No list found</p>
        )}
      </div>
    </div>
  );
};

export default Lists;
